module.exports = "<ota-dialog disbledClose=\"true\" class=\"dialog-alert\">\n\n  <!-- contnet -->\n  <div class=\"dialog-success-content\">\n    <div class=\"box-success\">\n      <span class=\"{{ icon }}\"></span>\n    </div>\n    <p class=\"font-16px color-main body-text\" [innerHtml]=\"text\"></p>\n    <div class=\"action-button\">\n      <button class=\"ota-btn-main\" md-dialog-close>{{'btn-ok' | translate}}</button>\n    </div>\n  </div>\n\n</ota-dialog>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/modal/dialog-success/dialog-success.component.html
// module id = 1072
// module chunks = 22